import { ComponentStore } from '@ngrx/component-store';

/**
 * Thin {@link ComponentStore} wrapper used by state services that already
 * extend another base class (e.g. `BaseService`) and therefore hold the store
 * via composition rather than inheritance.
 *
 * It exposes a public synchronous {@link snapshot} over ComponentStore's
 * protected `get`, so existing synchronous getters/setters on the service keep
 * working exactly as before while their backing state becomes reactive (via
 * `select`) for templates.
 */
export class LocalComponentStore<T extends object> extends ComponentStore<T> {
    constructor(initialState: T) {
        super(initialState);
    }

    /** Synchronous snapshot of the whole state. */
    snapshot(): T;
    /** Synchronous snapshot of a projection of the state. */
    snapshot<R>(projector: (state: T) => R): R;
    snapshot<R>(projector?: (state: T) => R): T | R {
        return projector ? this.get(projector) : this.get();
    }
}
